import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AnimatedRoutes from "./AnimatedRoutes";
import { GlobalContextProvider } from './components/globalContext/GlobalContext';
import { ToastError } from "./components/Icons/Icons";
import { checkIsMobile } from "./Reducer/globalSlice";
import "./App.css";
import "leaflet/dist/leaflet.css";
import "react-toastify/dist/ReactToastify.css";
import AnalyticsTracker from "./AnalyticsTracker";


function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    const typeOfDevice =
      window.innerWidth < 760
        ? "mobile"
        : window.innerWidth < 1023
          ? "tab"
          : "laptop";

    dispatch(checkIsMobile(typeOfDevice))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <GlobalContextProvider>
      <Router>
        <AnalyticsTracker />
        <AnimatedRoutes />
        <ToastContainer
          icon={({ type, theme }) => {
            switch (type) {
              case 'error':
                return <ToastError />;
              default:
                return null;
            }
          }}

          position="top-center"
          autoClose={1000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </GlobalContextProvider>
  );
}

export default App;
